"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = void 0;
var formatPhoneNumber_1 = require("./formatPhoneNumber");
Object.defineProperty(exports, "formatPhoneNumber", { enumerable: true, get: function () { return formatPhoneNumber_1.formatPhoneNumber; } });
